import React from 'react';
import { FlameIcon, GiftIcon, MessagesSquareIcon, ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_PRICE, formatPrice } from '../data/config';
import { offerBonuses, offerVolumes } from '../data/content';
import { CheckItem } from './CheckItem';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type OfferSectionProps = {
  showReferencePrices: boolean;
  guaranteeEnabled: boolean;
};
export function OfferSection({
  guaranteeEnabled
}: OfferSectionProps) {
  return <section id="offer" className="scroll-mt-2 bg-white px-4 py-6 text-center md:px-12 md:py-8" data-id="element-128" data-mp="mds5tk909kb7">
      <p className="font-heading text-[11px] font-bold uppercase tracking-[0.3em] text-goldDark md:text-[12px]" data-id="element-129" data-mp="rey4dypck1sn">
        Special launch offer
      </p>

      <div className="mx-auto mt-1.5 max-w-[540px] rounded-lg border-2 border-gold bg-surface px-3 pb-4 pt-3 md:px-5" data-id="element-130" data-mp="2t59inaxtfelv">
        <h2 className="font-heading text-[22px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-navy md:text-[28px]" data-id="element-131" data-mp="2y3uivad2hyab">
          <MessagesSquareIcon className="mr-1.5 inline h-6 w-6 -translate-y-0.5 text-brand" strokeWidth={2.5} aria-hidden data-id="element-132" data-mp="12oa7mstdk3i6" />
          Complete AAC Communication Toolkit™
        </h2>
        <p className="mx-auto mt-1 max-w-[420px] font-heading text-[11px] font-bold uppercase leading-[1.35] text-brand md:text-[12px]" data-id="element-133" data-mp="swxdfuk3t18z">
          The advanced clinical resource collection for Speech-Language Pathologists
        </p>

        <div className="mx-auto mt-2.5 max-w-[220px]" data-id="element-134" data-mp="1lll5qa39sqw1">
          <ProductImage data-id="element-135" data-mp="1gn1im6cxx923" />
        </div>

        <p className="mt-2 font-heading text-[13px] font-extrabold uppercase text-navy md:text-[14px]" data-id="element-136" data-mp="1go2u2bxvbxkc">
          6 Professional Volumes + 5 FREE Bonuses
        </p>
        <ul className="mx-auto mt-1.5 max-w-[440px] space-y-0.5 text-left text-[14px] leading-[1.4] text-ink md:text-[15px]" data-id="element-137" data-mp="17ljtxzlgvz1s">
          {offerVolumes.map(item => <CheckItem key={item} data-id="element-138" data-mp="3sd3u3s1ctez3">{item}</CheckItem>)}
        </ul>

        <p className="mt-3 flex items-center justify-center gap-1.5 font-heading text-[13px] font-extrabold uppercase text-goldDark md:text-[14px]" data-id="element-139" data-mp="3sewzl408dt5i">
          <GiftIcon className="h-4 w-4 shrink-0" strokeWidth={2.5} aria-hidden data-id="element-140" data-mp="2nyafhjkmmtl" />
          Plus 5 free bonuses
        </p>
        <ul className="mx-auto mt-1.5 max-w-[440px] space-y-0.5 text-left text-[14px] leading-[1.4] text-ink md:text-[15px]" data-id="element-141" data-mp="3ksrttqvizdu4">
          {offerBonuses.map(item => <CheckItem key={item} data-id="element-142" data-mp="3b38a6izznfy7">{item}</CheckItem>)}
        </ul>

        <div className="mx-auto mt-3 max-w-[440px] border-y border-line py-2" data-id="element-143" data-mp="3ftyfjw8ezisw">
          <p className="font-heading text-[14px] font-extrabold uppercase text-navy md:text-[15px]" data-id="element-144" data-mp="3fw1g3a770ubv">
            11 professional resources
          </p>
          <p className="font-heading text-[12px] font-extrabold uppercase text-brand md:text-[13px]" data-id="element-145" data-mp="365gi9ozcftu0">
            390 pages of advanced AAC materials
          </p>
        </div>

        <p className="mt-3 flex items-center justify-center gap-1.5 font-heading text-[14px] font-extrabold uppercase leading-tight text-navy md:text-[16px]" data-id="element-146" data-mp="2x48kr94nix0z">
          <FlameIcon className="h-4 w-4 shrink-0 fill-flameFill text-flame" strokeWidth={2} aria-hidden data-id="element-147" data-mp="2dk1e9mfy0ep8" />
          Get the complete collection today for just
        </p>
        <p className="mt-1 font-heading text-[46px] font-extrabold leading-none tracking-[-1px] text-gold md:text-[54px]" data-id="element-148" data-mp="2mjenqf42h39y">
          {formatPrice(PRODUCT_PRICE)} <span className="text-[18px] tracking-normal text-navy md:text-[20px]" data-id="element-149" data-mp="2wgjdeox4fgvi">USD</span>
        </p>

        <div className="mt-2.5" data-id="element-150" data-mp="2rhzocfn8doyx">
          <CtaButton mode="checkout" subtext="Instant Digital Delivery" className="max-w-none min-h-[64px]" data-id="element-151" data-mp="2rgojsdlyod6r">
            Get instant access
          </CtaButton>
        </div>

        {guaranteeEnabled && <p className="mx-auto mt-2.5 max-w-[420px] font-heading text-[11px] font-bold uppercase leading-snug text-navy md:text-[12px]" data-id="element-152" data-mp="318ufnyfc3er8">
            <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-brand" aria-hidden data-id="element-153" data-mp="3f4y6riuwv6zh" />
            7-day money-back guarantee <span className="text-gold" data-id="element-154" data-mp="18jtpxcijj12i">•</span> 6 volumes + 5 free bonuses
          </p>}
      </div>
    </section>;
}